module.exports = __webpack_public_path__ + "static/media/evening.48522282.png";